<template>
  <transition name="snackbar">
    <div v-if="isVisible" class="snackbar" :class="`${type}_color`">
      <div class="snackbar-content">
        <span class="snackbar-message">{{ message }}</span>
        <button v-if="showCloseButton" @click="close" class="snackbar-close">
          ×
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SnackBar',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'success_color', // success_color, error_color, warning_color, info_color
    },
    duration: {
      type: Number,
      default: 3000, // 3秒
      // default: 1000000,
    },
    showCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isVisible(newVal) {
      if (newVal && this.duration > 0) {
        setTimeout(() => {
          this.close();
        }, this.duration);
      }
    },
    // ページ移動時にスナックバーを閉じる
    $route() {
      if (this.isVisible) {
        this.close();
      }
    },
  },
  methods: {
    close() {
      // 親コンポーネントにイベントを送信
      this.$emit('close');
      // 直接Vuexストアの状態をリセット
      this.$store.dispatch('market/hideSnackbar');
    },
  },
};
</script>

<style lang="scss" scoped>
.snackbar {
  position: fixed;
  bottom: 80px; // フッターメニューの上に表示
  right: calc(100% / 6 * 1.5); // カートボタンの位置（右から2番目の中央）
  transform: translateX(50%);
  z-index: 999;
  max-width: 200px;
  min-width: 150px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;

  .snackbar-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-radius: 25px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    font-size: 11px;
    font-weight: 500;
    color: white;
    line-height: 1.2;
  }

  &.success_color .snackbar-content {
    background-color: #1d9c20cf !important;
  }

  &.error_color .snackbar-content {
    background-color: #e23c30d1 !important;
  }

  &.warning_color .snackbar-content {
    background-color: #ff9900ba !important;
  }

  &.info_color .snackbar-content {
    background-color: #2195f3b6 !important;
  }

  .snackbar-message {
    flex: 1;
  }

  .snackbar-close {
    background: none;
    border: none;
    color: white;
    font-size: 18px;
    cursor: pointer;
    padding: 0;
    margin-left: 8px;
    min-width: 20px;
    &:hover {
      opacity: 0.8;
    }
  }
}

// トランジション効果
.snackbar-enter-active,
.snackbar-leave-active {
  transition: all 0.3s ease;
}

.snackbar-enter-from,
.snackbar-leave-to {
  opacity: 0;
  transform: translateX(50%) translateY(20px);
}

.snackbar-enter-to,
.snackbar-leave-from {
  opacity: 1;
  transform: translateX(50%) translateY(0);
}

@media screen and (max-width: 768px) {
  .snackbar {
    bottom: 60px;
    right: calc(100% / 6 * 1.5);
    max-width: 180px;
    min-width: 120px;

    .snackbar-content {
      padding: 8px 10px;
      font-size: 11px;
    }
  }
}
</style>
